module.exports = __webpack_public_path__ + "static/media/myremedy_logo.5e3a879f.png";